module.exports = __webpack_public_path__ + "img/0.06cf3792.png";